import { UserProjectOrganizationTypeEnumType } from 'shared/common/global-types.runtime'
export const isProviderUser = (arg: any) =>
  arg === UserProjectOrganizationTypeEnumType.Provider

export const isThirdPartyUser = (arg: any) =>
  arg === UserProjectOrganizationTypeEnumType.ThirdParty

export const isCustomerUser = (arg: any) =>
  arg === UserProjectOrganizationTypeEnumType.Customer
